// extracted by mini-css-extract-plugin
module.exports = {"show-more-btn":"PaginatorLoadMoreButton_show-more-btn__MbCYU","paginator__show-more":"PaginatorLoadMoreButton_paginator__show-more__1T_YQ"};